import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getLeaseDealsValueRating } from 'client/site-modules/lease-deals/utils/get-lease-deals-value-rating';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { RATING_DESCRIPTIONS, RATING_LABELS } from './payment-ratio-insights-utils';

import './payment-ratio-insights.scss';

const RATING_BG_COLOR_MAP = {
  1: 'bg-orange-90',
  2: 'bg-blue-90',
  3: 'bg-blue-90',
  4: 'bg-gem-1',
  5: 'bg-gem-1',
};

const RATING_IMAGE_MAP = {
  1: 'thumb-down-orange-30.svg',
  2: 'list-blue-50.svg',
  3: 'list-blue-50.svg',
  4: 'gem-1.svg',
  5: 'gem-1.svg',
};

export function PaymentRatioInsights({ effectivePaymentRatio, className = null }) {
  const { rating, maxRating } = getLeaseDealsValueRating(effectivePaymentRatio);

  return (
    <div
      className={classNames(
        'payment-ratio-insights p-1_5 text-center rounded-20',
        RATING_BG_COLOR_MAP[rating],
        className
      )}
    >
      <div className="payment-ratio-insights-icon bg-white rounded-circle d-flex justify-content-center align-items-center mx-auto mb-1">
        <img src={getStaticImageUrl(`/img/lease-deals/${RATING_IMAGE_MAP[rating]}`)} alt="" />
      </div>
      <div className="text-cool-gray-10 size-24 fw-bold mb-1">
        {rating}/{maxRating} {RATING_LABELS[rating]}
      </div>
      <p className="size-16 m-0">{RATING_DESCRIPTIONS[rating]}</p>
    </div>
  );
}

PaymentRatioInsights.propTypes = {
  effectivePaymentRatio: PropTypes.number.isRequired,
  className: PropTypes.string,
};
